import { OfficeServiceEnum } from "../../components/enums/OfficeService";
import { OfficePersistor } from "../OfficePersistor";
import { OutlookPersistor } from "../OutlookPersistor";
import { IPersistor } from "../../interfaces/IPersistor";
import { IMailSendPayload } from "../../interfaces/IMailSendPayload";
import { ModeEnum } from "../../components/enums/modeEnum";
import { IPageSettings } from "../../interfaces/IPageSettings";

export class PersistorFactory {
  static create(serviceType: OfficeServiceEnum, mailSendPayload: IMailSendPayload, mode: ModeEnum, isFileSystemFileUpload: boolean, disableMailCategorization?: boolean, isTessEnabled?: boolean, workingDirectories?: IPageSettings[]): IPersistor {
    switch (serviceType) {
      case OfficeServiceEnum.outlook:
        return new OutlookPersistor(mailSendPayload, mode, disableMailCategorization ?? false, isTessEnabled ?? false, workingDirectories);
      default:
        return new OfficePersistor(isFileSystemFileUpload);
    }
  }
}
